import { useNavigate } from "react-router-dom";
import "../../styles/sidebar_styles/SystemAdministratorSideBar.css";
import { useContext, useEffect, useRef } from "react";
import { AppContext } from "../AppProvider";

const SystemAdministratorSideBar = () =>{
    const {
        showSideBar,setShowSideBar,
        mobileSideBarLauncherRef
    } = useContext(AppContext);
    const systemAdministratorSideBarRef = useRef(null);
    const navigate = useNavigate();
    const handleSystemAdministratorSideBarClick = (e) =>{
        if(mobileSideBarLauncherRef.current && !mobileSideBarLauncherRef.current.contains(e.target) &&
            systemAdministratorSideBarRef.current && !systemAdministratorSideBarRef.current.classList.contains('hidden')){
                setShowSideBar(false);
            }
    };
    useEffect(() =>{
        document.addEventListener('click',handleSystemAdministratorSideBarClick);
        return () =>{
            document.removeEventListener('click',handleSystemAdministratorSideBarClick);
        }
    });
    useEffect(() =>{
        if(!showSideBar && systemAdministratorSideBarRef.current && !systemAdministratorSideBarRef.current.classList.contains('hidden')){
            systemAdministratorSideBarRef.current.classList.add('hidden');
        }
        else if(showSideBar && systemAdministratorSideBarRef.current && systemAdministratorSideBarRef.current.classList.contains('hidden')){
            systemAdministratorSideBarRef.current.classList.remove('hidden');
        }
    },[showSideBar]);
    return(
        <div ref={systemAdministratorSideBarRef} className={`system-administrator-side-bar ${showSideBar? 'show':''}`}>
            <div className="system-administrator-side-bar-button-container" onClick={() => navigate('/')}>
                <img src={process.env.PUBLIC_URL + '/images/home-icon.png'} alt="."/>
                <button>Home</button>
            </div>
            <div className="system-administrator-side-bar-button-container" onClick={() => navigate('/system-admin/tenant-admins')}>
                <img src={process.env.PUBLIC_URL + '/images/tenant-administrator-icon.png'}/>
                <button>Tenant administrators</button>
            </div>
        </div>
    )
}
export default SystemAdministratorSideBar;